/** Lead Alchemy mark: three rising bars on a black tile (inverted on dark panels by CSS). */
export function RnrMark({size=32}:{size?:number}){
 return <svg className="rnr-mark" width={size} height={size} style={{width:size,height:size}} viewBox="0 0 32 32" aria-hidden="true">
  <rect className="rnr-mark__tile" width="32" height="32" rx="7"/>
  <rect className="rnr-mark__bar" x="8" y="17" width="4" height="8" rx="1" opacity=".55"/><rect className="rnr-mark__bar" x="14" y="12" width="4" height="13" rx="1" opacity=".8"/><rect className="rnr-mark__bar" x="20" y="7" width="4" height="18" rx="1"/>
 </svg>;
}

export function RnrBrand({tagline}:{tagline?:string}){
 return <div className="brand rnr-brand"><RnrMark/><span className="rnr-brand__text"><span className="rnr-brand__name">Lead <b>Alchemy</b></span>{tagline&&<small>{tagline}</small>}</span></div>;
}
